import {LocationCarrierConfiguration} from '../../local-loads/shared/location-carrier-configuration.model';

export class CarrierDisplay {

  public id: string;
  public name: string;
  public vendorNumber: string;


  static fromLocationCarrierConfig(locationCarrierConfig: LocationCarrierConfiguration): CarrierDisplay {
    if (!locationCarrierConfig) {
      return null;
    }

    const carrierDisplay = new CarrierDisplay();

    carrierDisplay.id                       = locationCarrierConfig.carrierId;
    carrierDisplay.name                     = locationCarrierConfig.carrierName;
    carrierDisplay.vendorNumber             = locationCarrierConfig.vendorNumber;

    return carrierDisplay;
  }


  static fromDto(c): CarrierDisplay {
    if (!c) {
      return null;
    }

    const carrierDisplay = new CarrierDisplay();

    carrierDisplay.id                       = c.id;
    carrierDisplay.name                     = c.name;
    carrierDisplay.vendorNumber             = c.vendorNumber;

    return carrierDisplay;
  }

}
